<script lang="ts" setup>
    import { inject, onMounted, reactive } from 'vue';
    import type { FormField, FormFieldsReference } from './FormEditor.types';
    import { addItemToList } from './FormEditor';
    import { getAllFormFields } from './AllFormFields';
    import { AccountAccess } from '@cwd/Account/Account.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const accountAccess: AccountAccess = injectorAccess.injector.get(AccountAccess);

    const props = defineProps<{
        formFields: FormFieldsReference;
    }>();

    const state = reactive<{ allFormFields: FormFieldsReference }>({ allFormFields: [] });

    onMounted(async () => {
        state.allFormFields = getAllFormFields($Resources, accountAccess.state.currentAccount!.CustomField as any);
    });

    const isAdded = (formField: FormField) => {
        return props.formFields.find((addedFormField: FormField) => {
            return addedFormField.contactField === formField.contactField;
        });
    };
</script>

<template>
    <li v-for="formField in state.allFormFields" :key="formField.contactField">
        <a
            class="text-wrap"
            href="javascript:void(0)"
            v-show="!isAdded(formField)"
            @click="
                addItemToList(props.formFields, {
                    contactField: formField.contactField,
                    type: formField.type,
                    label: formField.label,
                    description: formField.description,
                    required: formField.required,
                    placeholder: formField.placeholder,
                    options: formField.options?.map((o) => ({ ...o })),
                })
            ">
            {{ formField.label }}
        </a>
    </li>
</template>

<style></style>

<style scoped></style>
